/* Name: ListSW.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/


import axios, { AxiosResponse } from 'axios';
//import React from 'react';
import { ChangeEvent, useState, useEffect } from 'react';
import ListItems from './baseList';
import { sm4request } from './tokenInterceptor';

//const API_SERVER = import.meta.env.VITE_API_SERVER as string;
//const BLOB_SIZE_LIMIT = import.meta.env.VITE_API_BLOB_SIZE_LIMIT;
const containerName = `m-sm4-filemanager-updates-blob-container`;

type ListResponse = {
  list: string[];
};

type swlist = {
  name: string[];
  meta: string[];
};


const fetchapidata = async (url) : Promise<string[]> => {
    const data = await sm4request.get(`/api/${url}`)
    .then((result: AxiosResponse<ListResponse>) => {
      const { data } = result;
      const { list } = data;
      return list;
    })
    return data;
  };

export const FilterButton = (props) => {
  return (
    <button
      type="button"
      className="btn toggle-btn"
      aria-pressed={props.isPressed}
      onClick={() => props.setFilter(props.name)}>
      <span className="visually-hidden">Show </span>
      <span>{props.name}</span>
      <span className="visually-hidden"> tasks</span>
    </button>
  );
}


function listSWItems(props) {

  const [list, setList] = useState<swlist[]>([]);
  const lista = ["sw", "pw"]

// ***** fetch BLOBs within a container in JSON format
// ***** and link fields to chosen headers.
// Example data:
// http://localhost:7071/api/list?permission=w&container=m-sm4-filemanager-updates-blob-container

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'name', width: 200 },
    { field: 'reviewedBy',
    valueGetter: (value, row) => {
      return `${row.metadata.reviewedBy || ''}`;
    },
    headerName: 'reviewer', width: 150 },
    { field: 'releasedBy',
    valueGetter: (value, row) => {
      return `${row.metadata.releasedBy || ''}`;
    },
    headerName: 'releaser', width: 150 },
    { field: 'createdOn',
    valueGetter: (value, row) => {
      return `${row.properties.createdOn || ''}`;
    },
    headerName: 'Created', width: 150 },
  ];


  useEffect(() => {
    (async () => {
        const newData = await fetchapidata(`list?container=${containerName}`);
        setList(newData);
        console.log(newData);
        //fetch('https://jsonplaceholder.typicode.com/users')
        //  .then(response => response.json())
        //  .then(json => setList(json))
          //.then(json => console.log(json))
    })();
  }, []);

  return(
    <ListItems
        rows={list}
        columns={columns}
        loading={!list.length}
    />
  );
};

export default listSWItems;